import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit-html';
import { css } from 'lit';
import { theme } from '../common/theme';
import { IconName } from '../te-icon';
import { TeButtonBase } from './te-button-base';
import '../te-spacing';
import '../te-text';
import '../te-loader';

/** Button with Loader Component */
@customElement('te-button-loader')
export class TeButtonLoader extends TeButtonBase {
  static styles = [
    ...TeButtonBase.styles,
    css`
      button {
        position: relative;
        padding: 0;
        justify-content: center;
        border-radius: 40px;
      }

      te-loader {
        position: absolute;
        height: 40px;
        top: 0;
        left: 0;
      }
    `,
  ];

  /** Icon name from icon pack */
  @property({ type: String }) icon?: IconName;
  /** Size of the icon */
  @property({ type: Number }) iconSize = 16;
  /** Color for icon svg */
  @property({ type: String }) iconColor = theme.colors.text.toString();
  /** Progress value between 0 and 100 */
  @property({ type: Number }) loaderProgress?: number;

  getBackgroundColor() {
    return this.backgroundColor || theme.colors.shade0.toString();
  }

  renderIcon() {
    if (!this.icon) return;
    return html`
      <te-icon
        name=${this.icon}
        size=${this.iconSize}
        color=${this.iconColor}
        wrapperSize="1"
      ></te-icon>
    `;
  }

  renderLoader() {
    if (this.loaderProgress !== undefined) {
      return html`
        <te-loader size="40" progress=${this.loaderProgress}></te-loader>
      `;
    }
    return html`
      <te-loader size="40"></te-loader>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-button-loader': TeButtonLoader;
  }
}
